<div class="card">
  <div class="title">{{ data.title | translate }}</div>
  <div class="number">
    {{ data.totalCount | number }}
  </div>

  <div class="subcard">
    <canvas
      baseChart
      [data]="getDonutData(data.categories)"
      [type]="'doughnut'"
      [options]="donutOptions"
      [height]="120"
      [width]="120"
    >
    </canvas>
    <div class="category-legend">
      <div class="legend-item" *ngFor="let cat of data.categories">
        <label
          ><span class="dot" [ngStyle]="{ backgroundColor: cat.color }"></span>
          <label>{{ cat.name | translate}}</label></label
        >

        <strong>{{ cat.count | number : "1.0-0" }}</strong>
      </div>
    </div>
  </div>
</div>
